import React, { useState } from 'react'
import { PiCaretDownBold, PiCaretUpBold } from 'react-icons/pi'
import './Accordion.scss'

interface AccordionProps {
  title: string
  content: string
  boldTitle?: boolean
  noHeaderBottomMargin?: boolean
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  content,
  boldTitle,
  noHeaderBottomMargin,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className="accordion">
      <div
        className={`accordion__header ${
          boldTitle ? 'accordion__header--bold' : ''
        } ${noHeaderBottomMargin ? 'accordion__header--no-bottom-margin' : ''}`}
        onClick={toggleAccordion}
      >
        <span
          className="accordion__title"
          dangerouslySetInnerHTML={{ __html: title }}
        ></span>
        {isOpen ? (
          <div style={{ width: 20 }}>
            <PiCaretUpBold height={20} className="accordion__icon" />
          </div>
        ) : (
          <div style={{ width: 20 }}>
            <PiCaretDownBold height={20} className="accordion__icon" />
          </div>
        )}
      </div>
      {isOpen && (
        <div
          className="accordion__content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
  )
}

export default Accordion
